import { ComponentChildren, h } from "preact";
import { useCallback, useLayoutEffect, useRef } from "preact/hooks";
import { fallbackSetAnchorPosition } from "./fallbacks";
import { findAnchorElement, supportsAnchorPositioning } from "services/anchors";
import "./popover.scss";

// there seems to be chrome bugs with anchor layout where it cant anchor against the right edge...

export function Popover(props: { children: ComponentChildren, visible: boolean, target?: string | null, onToggle?: (newState: "open" | "closed") => void }) {
    const ref = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (!supportsAnchorPositioning && props.visible && props.target && ref.current) {
            const anchor = findAnchorElement(props.target);
            if (!anchor) return;
            fallbackSetAnchorPosition(anchor, ref.current);
        }

        if (props.visible && ref.current && !ref.current.hasAttribute("open")) {
            (ref.current as any).showPopover();
            ref.current.setAttribute("open", "true");
        }
        if (!props.visible && ref.current && ref.current.hasAttribute("open")) {
            ref.current.removeAttribute("open");
            (ref.current as any).hidePopover();
        }
    }, [props.visible, props.target])

    const onToggle = useCallback((e: h.JSX.TargetedEvent<HTMLDivElement, Event>) => {
        props.onToggle?.((e as any).newState);
    }, [props.onToggle]);

    return (
        <div ref={ref}
            // @ts-ignore
            popover="auto"
            onToggle={onToggle}
            class="popover" style={{
                //visibility: (!props.visible || !props.target) ? "hidden" : undefined,
                positionAnchor: (supportsAnchorPositioning ? props.target : undefined) ?? undefined
            }}>
            {
                props.children
            }
        </div>
    );
}
